import React from "react";
import Layout from "../components/Layout";
import "./Pricing.css";
import { subscriptionData, creditData, dataQuestionAnswer } from "../data/data";
import { useState } from "react";
import profile from "../assets/images/profile.png";
import {useHistory} from 'react-router-dom'
export default function Pricing() {
  const [showMoreSub, setShowMoreSub] = useState(false);
  const [showMoreCredit, setShowMoreCredict] = useState(false);
  const history = useHistory()
  const handleCheckOut = ()=>{
    history.push('/checkouts')
  }
  const handleShowMoreSub = () => {
    setShowMoreSub(!showMoreSub);
  };
  const handleShowMoreCredit = () => {
    setShowMoreCredict(!showMoreCredit);
  };
  return (
    <Layout>
      <section className="pricing-container">
        <h2
          style={{
            color: "rgb(69, 69, 69);",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "40px",
          }}
        >
          Get Full Resolution Images
        </h2>
        <p
          style={{
            color: "rgb(69, 69, 69);",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          1 IMAGE = 1 CREDIT <span>or less</span>{" "}
        </p>
        <div className="pricing-card">
          <div className="ctn-card card-left">
            <div className="card-left-up">
              <div>
                <h2
                  style={{
                    textAlign: "center",
                    padding: "5px",
                    fontSize: "25",
                  }}
                >
                  Subscription Plan
                </h2>
                <p
                  style={{
                    color: "rgb(38, 153, 251)",
                    fontSize: "20px",
                    fontWeight: "bold",
                    textAlign: "center"
                  }}
                >
                  $ 0.20 / image
                </p>
              </div>

              <table
                className="card-left-up-option"
                style={{
                  minHeight: "150px",
                }}
              >
                {subscriptionData.map((item, idx) => {
                  if (showMoreSub) {
                    return (
                      <Option
                        unit={item.unit}
                        total={item.total}
                        price={item.price}
                        type="true"
                      />
                    );
                  } else {
                    if (idx < 4) {
                      return (
                        <Option
                          unit={item.unit}
                          total={item.total}
                          price={item.price}
                          type="true"
                        />
                      );
                    }
                  }
                })}
              </table>
            </div>
            <div className="show-more" onClick={handleShowMoreSub}>
              {showMoreSub ? "Show less" : "Show more"}
            </div>
            <Btn
              btn={"Subcribe now"}
              text={"$ 39 per month, price incl. VAT, if applicable"}
              handleCheckOut={handleCheckOut}
            />
            <div
              className="card-left-low"
              style={{
                borderTop: "1px solid #eee",
                backgroundColor: "rgb(233, 235, 236)",
                width: "100%",
                padding: "15px",
              }}
            >
              <p
                style={{
                  marginBottom: "auto",
                  textAlign: "center",
                  color: "rgb(69, 69, 69)",
                }}
              >
                Risk free: 14 Days Money Back Guarantee{" "}
              </p>
              <p
                style={{
                  marginBottom: "auto",
                  textAlign: "center",
                  color: "rgb(69, 69, 69)",
                }}
              >
                Flexible: Downgrade, upgrade or cancel any time{" "}
              </p>
              <p
                style={{
                  marginBottom: "auto",
                  textAlign: "center",
                  color: "rgb(69, 69, 69)",
                }}
              >
                Fair: Unused credits roll over as long as you're subscribed
              </p>
            </div>
          </div>

          <div className="ctn-card card-right">
            <div>
              <h2
                style={{ textAlign: "center", padding: "5px", fontSize: "25" }}
              >
                Pay as you go
              </h2>
              <p
                style={{
                  color: "rgb(38, 153, 251)",
                  fontSize: "20px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                $ 0.90 / image
              </p>
            </div>
            <table
              className="card-right-up-option"
              style={{
                minHeight: "150px",
                // display: "flex",
                // flexDirection: "column",
                // justifyContent: "space-evenly",
              }}
            >
              {creditData.map((item, idx) => {
                if (showMoreCredit) {
                  return (
                    <Option
                      key={item.id}
                      unit={item.unit}
                      total={item.total}
                      price={item.price}
                    />
                  );
                } else {
                  if (idx < 4) {
                    return (
                      <Option
                        key={item.id}
                        unit={item.unit}
                        total={item.total}
                        price={item.price}
                      />
                    );
                  }
                }
              })}
            </table>
            <div className="show-more" onClick={handleShowMoreCredit}>
              {showMoreCredit ? "Show less" : "Show more"}
            </div>
            <Btn
              btn={"Buy now"}
              text={"$ 9 one-time payment, price incl. VAT, if applicable"}
              handleCheckOut={handleCheckOut}
            />
            <div
              className="card-right-low"
              style={{
                borderTop: "1px solid #eee",
                backgroundColor: "rgb(233, 235, 236)",
                width: "100%",
                padding: "15px",
              }}
            >
              <p
                style={{
                  marginBottom: "auto",
                  textAlign: "center",
                  color: "rgb(69, 69, 69)",
                }}
              >
                Credits available for use anytime{" "}
              </p>
              <p
                style={{
                  marginBottom: "auto",
                  textAlign: "center",
                  color: "rgb(69, 69, 69)",
                }}
              >
                within two years of purchase.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-container-midle">
        <div className="pricing-container-midle-title">All plans include:</div>
        <div className="pricing-container-midle-content">
          <div>
            <i className="fa-solid fa-infinity"></i>
            <p>Unlimited free previews on remove.bg</p>
          </div>
          <div>
            <i className="fa-solid fa-code"></i>
            <p>50 free previews via API and apps per month</p>
          </div>
          <div>
            <i className="fa-solid fa-wand-magic-sparkles"></i>
            <p>remove.bg for Adobe Photoshop</p>
          </div>
          <div>
            <i className="fa-solid fa-desktop"></i>
            <p>remove.bg for Windows / Mac / Linux</p>
          </div>
        </div>
      </section>
      <section className="pricing-container-question">
        <h3>Frequently asked questions</h3>
        <div className="pricing-container-question-content">
          {dataQuestionAnswer.map((item) => {
            return (
              <ButtonShowCase
                key={item.id}
                question={item.question}
                answers={item.answers}
                idx={item.id}
              />
            );
          })}
        </div>
      </section>
      <section className="pricing-container-bottom">
        <h3
          style={{
            margin: "auto",
            textAlign: "center",
            fontSize: "30px",
            color: "#54616C",
            padding: "5px",
          }}
        >
          Need more than 100,000 images?
        </h3>
        <div className="pricing-container-bottom-card">
          <h5
            style={{ textAlign: "center", fontSize: "18px", color: "#54616C" }}
          >
            Get in touch for a custom quote, a free demo, or to learn more about
            our flexible enterprise solutions.
          </h5>
          <button>Contact Us</button>
          <div className="pricing-container-profile">
            <img
              src={profile}
              alt="#"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "50%",
                backgroundColor: "#D7EFF3",
                marginRight: "10px",
              }}
            />
            <div style={{ padding: "2px" }}>
              <h5 style={{ color: "#54616C" }}>Erika Diskancova</h5>
              <p style={{ color: "#54616C" }}>Enterprise Account Executive</p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

const Option = ({ unit, total, price, type }) => {
  return (
    <tr>
      <td>
        <div style={{ marginRight: "50px" }}>
          <i
            style={{ marginRight: "5px", color: "rgb(38, 153, 251)" }}
            class="active-status-icon fas fa-dot-circle"
          ></i>
          {unit} credits
          <small>/ month</small>
        </div>
      </td>
      <td>
        <div>
          <span>$ {total}</span>
        </div>
      </td>
      <td style={{ marginRight: "auto" }}>
        <div>
          <strong>
            <span>
              <span style={{ fontWeight: "bold" }}>$ {price}</span>/ image
            </span>
          </strong>
        </div>
      </td>
    </tr>
  );
};

const Btn = ({ btn, text ,handleCheckOut}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "120px",
        justifyContent: "center",
        alignItems: "center",
        flex: "1",
      }}
    >
      <button
        onClick={handleCheckOut}
        style={{
          color: "#fff",
          backgroundColor: "rgb(38, 153, 251)",
          border: "none",
          height: "40px",
          width: "150px",
          borderRadius: "3px",
          padding: "2px",
          cursor: "pointer",
        }}
      >
        {btn}
      </button>
      <p
        style={{
          color: "rgb(69, 69, 69)",
          fontSize: "12px",
          marginTop: "3px",
          width: "80%",
          textAlign:"center",
        }}
      >
        {text}
      </p>
    </div>
  );
};

const ButtonShowCase = ({ question, answers, idx }) => {
  const [show, setShow] = useState(false);
  const handleClickShow = (idx) => {
    setShow(!show);
  };
  return (
    <div
      style={{ padding: "10px", border: "1px solid #ddd" }}
      className="btn-show-case-container"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p
          style={{ textAlign: "left", fontSize: "20px", color: "#5f5f5f" }}
          className="btn-question"
        >
          {question}
        </p>
        {!show ? (
          <i
            onClick={() =>
              handleClickShow(
                dataQuestionAnswer.filter((item) => item.id === idx)
              )
            }
            className="fa-solid fa-plus"
            style={{
              color: "rgb(38, 153, 251)",
              cursor: "pointer",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          ></i>
        ) : (
          <i
            onClick={() =>
              handleClickShow(
                dataQuestionAnswer.filter((item) => item.id === idx)
              )
            }
            className="fa-solid fa-minus"
            style={{
              color: "rgb(38, 153, 251)",
              cursor: "pointer",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          ></i>
        )}
      </div>
      {show && (
        <>
          {answers.map((item, idx) => {
            return (
              <>
                <br></br>
                <p
                  key={idx}
                  style={{
                    textAlign: "left",
                    fontSize: "16px",
                    color: "#5f5f5f",
                  }}
                  className="btn-answer"
                >
                  {item}
                </p>
              </>
            );
          })}
        </>
      )}
    </div>
  );
};
